import { createSelector } from 'reselect';

const selectSingleEvenemang = state => state.get('evenemangsingle');

const makeSelectEvenemang = () =>
  createSelector(selectSingleEvenemang, evenemangState =>
    evenemangState.get('evenemang'),
  );
  const makeSelectSubEvenemang = () =>
  createSelector(selectSingleEvenemang, evenemangState =>
    evenemangState.get('subevenemang'),
  );
  const getProfile = () =>
  createSelector(selectSingleEvenemang, evenemangState =>
    evenemangState.get('profile'),
  );
  const getOpen = () =>
  createSelector(selectSingleEvenemang, evenemangState =>
    evenemangState.get('open'),
  );
  const getTabValue = () =>
  createSelector(selectSingleEvenemang, evenemangState =>
    evenemangState.get('tabvalue'),
  );
  const getTabValueTitle = () =>
  createSelector(selectSingleEvenemang, evenemangState =>
    evenemangState.get('tabvaluetitle'),
  );
export { selectSingleEvenemang, makeSelectEvenemang,makeSelectSubEvenemang,getProfile,getOpen,getTabValue,getTabValueTitle };
